export default __webpack_public_path__ + "static/media/atomic-design.da7062be.webp";